(function () {
  'use strict';

  function initGuideTopics() {
    var container = document.querySelector('.franify-guide-container');
    if (!container) return;

    var content = container.querySelector('.single-guide-content');
    var list = container.querySelector('.single-guide-topics-list');
    var select = container.querySelector('.single-guide-topics-select');
    if (!content || !list || !select) return;

    // Reserve all existing IDs so generated anchors cannot shadow another element.
    var usedIds = new Set(Array.from(document.querySelectorAll('[id]'), function (element) {
      return element.id;
    }));

    content.querySelectorAll('h2').forEach(function (heading, index) {
      if (heading.closest('[data-guide-topics-exclude]')) return;
      var title = heading.textContent.trim();
      if (!title) return;

      // Keep author-defined anchors when they uniquely identify this heading.
      var sameId = heading.id ? Array.from(document.querySelectorAll('[id]')).filter(function (element) {
        return element.id === heading.id;
      }) : [];
      if (!heading.id || sameId.length > 1) {
        var slug = title.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        var base = 'guide-topic-' + (slug || String(index + 1));
        var id = base;
        var suffix = 2;
        while (usedIds.has(id)) id = base + '-' + suffix++;
        heading.id = id;
        usedIds.add(id);
      }
      heading.setAttribute('tabindex', '-1');

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + encodeURIComponent(heading.id);
      link.textContent = title;
      item.appendChild(link);
      list.appendChild(item);

      var option = document.createElement('option');
      option.value = heading.id;
      option.textContent = title;
      select.appendChild(option);
    });

    var links = Array.from(list.querySelectorAll('a'));
    var sections = links.map(function (link) {
      return document.getElementById(decodeURIComponent(link.hash.slice(1)));
    }).filter(Boolean);

    function setCurrentTopic(id) {
      // Avoid changing the selection while the native picker is being used.
      if (document.activeElement !== select) select.value = id;
      links.forEach(function (link) {
        if (decodeURIComponent(link.hash.slice(1)) === id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }

    function updateFromScroll() {
      var active = sections[0];
      if (!active) return;
      var offset = parseFloat(window.getComputedStyle(active).scrollMarginTop) || 120;
      sections.forEach(function (section) {
        if (section.getBoundingClientRect().top <= offset + 8) active = section;
      });
      // The final heading can be too close to the document end to reach the offset.
      if (window.scrollY > 0 && window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2) {
        active = sections[sections.length - 1];
      }
      setCurrentTopic(active.id);
    }

    var pending = false;
    function scheduleUpdate() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        updateFromScroll();
      });
    }

    select.addEventListener('change', function () {
      var target = document.getElementById(select.value);
      if (!target) return;
      window.location.hash = encodeURIComponent(target.id);
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
      target.focus({ preventScroll: true });
      setCurrentTopic(target.id);
    });
    select.addEventListener('blur', scheduleUpdate);

    list.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (target) target.focus({ preventScroll: true });
    });
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('hashchange', scheduleUpdate);
    window.addEventListener('load', scheduleUpdate);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleUpdate);
    scheduleUpdate();

    // Generated anchors also work when a visitor opens a direct section link.
    if (window.location.hash) {
      try {
        var target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
        if (target && content.contains(target)) target.scrollIntoView();
      } catch (error) {
        // Ignore malformed URL fragments.
      }
    }
  }

  function initBackToTop() {
    var container = document.querySelector('.franify-guide-container');
    if (!container) return;
    var content = container.querySelector('.single-guide-content');
    var button = container.querySelector('.single-guide-back-to-top');
    var topics = container.querySelector('.single-guide-topics');
    if (!content || !button) return;

    function update() {
      var rect = content.getBoundingClientRect();
      button.hidden = window.scrollY <= 0 || rect.top >= window.innerHeight;
      var mobile = !window.matchMedia('(min-width: 768px)').matches;
      if (mobile) {
        button.style.right = '16px';
        button.style.bottom = ((topics ? topics.getBoundingClientRect().height : 0) + 20) + 'px';
      } else {
        // Sit outside the article where space permits, otherwise stay inside the viewport.
        button.style.right = Math.max(16, document.documentElement.clientWidth - rect.right - 16 - 56) + 'px';
        button.style.bottom = '24px';
      }
    }
    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; update(); });
    }
    button.addEventListener('click', function () {
      var title = container.querySelector('#single-guide-title');
      if (title) {
        title.setAttribute('tabindex', '-1');
        title.focus({ preventScroll: true });
      }
      window.scrollTo({
        top: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if (window.ResizeObserver) {
      var observer = new window.ResizeObserver(schedule);
      observer.observe(content);
      if (topics) observer.observe(topics);
    }
    update();
  }

  function initContentImageLightbox() {
    var container = document.querySelector('.franify-guide-container');
    if (!container) return;

    var content = container.querySelector('.single-guide-content');
    var lightbox = container.querySelector('.single-guide-image-lightbox');
    if (!content || !lightbox) return;

    var lightboxImage = lightbox.querySelector('img');
    var closeButton = lightbox.querySelector('.single-guide-image-lightbox-close');
    var backdrop = lightbox.querySelector('.single-guide-image-lightbox-backdrop');
    var activeTrigger = null;
    if (!lightboxImage || !closeButton || !backdrop) return;

    function imageLabel(image) {
      var description = image.getAttribute('alt');
      return description ? 'Open full-size image: ' + description : 'Open full-size image';
    }

    function largestImageSource(image) {
      var candidates = (image.getAttribute('srcset') || '').split(',').map(function (candidate) {
        var parts = candidate.trim().split(/\s+/);
        var width = parts[1] && /w$/.test(parts[1]) ? parseInt(parts[1], 10) : 0;
        return { src: parts[0], width: width };
      }).filter(function (candidate) {
        return candidate.src;
      });

      candidates.sort(function (first, second) { return second.width - first.width; });
      return candidates.length ? candidates[0].src : (image.currentSrc || image.src);
    }

    function fullSizeSource(image) {
      var link = image.closest('a');
      var href = link ? link.getAttribute('href') : '';
      if (href && /\.(?:avif|gif|jpe?g|png|svg|webp)(?:[?#]|$)/i.test(href)) return href;
      return largestImageSource(image);
    }

    function openLightbox(image) {
      activeTrigger = image.closest('a, button') || image;
      lightboxImage.src = fullSizeSource(image);
      lightboxImage.alt = image.getAttribute('alt') || '';
      lightbox.hidden = false;
      document.body.classList.add('single-guide-lightbox-open');
      closeButton.focus();
    }

    function closeLightbox() {
      if (lightbox.hidden) return;
      lightbox.hidden = true;
      lightboxImage.removeAttribute('src');
      lightboxImage.alt = '';
      document.body.classList.remove('single-guide-lightbox-open');
      if (activeTrigger) activeTrigger.focus();
      activeTrigger = null;
    }

    content.querySelectorAll('img').forEach(function (image) {
      if (image.closest('.wp-block-franify-quick-callout, .wp-block-franify-related-guide')) return;

      var link = image.closest('a');
      if (link) {
        link.setAttribute('data-single-guide-image-trigger', '');
        link.setAttribute('aria-haspopup', 'dialog');
        if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', imageLabel(image));
      } else {
        image.setAttribute('data-single-guide-image-trigger', '');
        image.setAttribute('role', 'button');
        image.setAttribute('tabindex', '0');
        image.setAttribute('aria-haspopup', 'dialog');
        image.setAttribute('aria-label', imageLabel(image));
      }
    });

    content.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-single-guide-image-trigger]');
      if (!trigger || !content.contains(trigger)) return;
      var image = trigger.matches('img') ? trigger : trigger.querySelector('img');
      if (!image || !content.contains(image)) return;
      if (image.closest('.wp-block-franify-related-guide')) return;
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      openLightbox(image);
    });

    content.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var image = event.target.closest('img[role="button"]');
      if (!image || !content.contains(image)) return;
      if (image.closest('.wp-block-franify-related-guide')) return;
      event.preventDefault();
      openLightbox(image);
    });

    closeButton.addEventListener('click', closeLightbox);
    backdrop.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'Tab') {
        event.preventDefault();
        closeButton.focus();
      }
    });
  }

  function init() {
    initGuideTopics();
    initBackToTop();
    initContentImageLightbox();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
